import { render } from "./legoGridRow.vue?vue&type=template&id=3291b18c"
import script from "./legoGridRow.vue?vue&type=script&lang=js"
export * from "./legoGridRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoGrid/legoGridRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3291b18c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3291b18c', __exports__)) {
    api.reload('3291b18c', __exports__)
  }
  
  module.hot.accept("./legoGridRow.vue?vue&type=template&id=3291b18c", () => {
    api.rerender('3291b18c', render)
  })

}


export default __exports__